import LazyLoad from "vanilla-lazyload";

let myLazyLoad = new LazyLoad();

export default myLazyLoad;